import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Truck, ShoppingBag, Star, Sparkles } from "lucide-react";
import { Header, Footer } from "@/components/customer/Layout";
import { WelcomeDialog } from "@/components/customer/WelcomeDialog";

const HERO = "https://images.unsplash.com/photo-1611280422374-fa3c1110c16e?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="bg-white min-h-screen">
      <WelcomeDialog />
      <div className="bg-brand-red text-white text-center px-4 py-2.5 text-sm font-medium flex items-center justify-center gap-2" data-testid="home-announcement">
        <Sparkles className="w-4 h-4 shrink-0" />
        <span><strong>Bienvenue sur notre tout nouveau site&nbsp;!</strong> C'est désormais ici que vous commandez, en direct et au meilleur prix.</span>
      </div>
      <Header />

      <section className="relative min-h-[78vh] flex items-end" data-testid="home-hero">
        <img src={HERO} alt="Wok" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative max-w-6xl mx-auto px-4 pb-16 text-white w-full">
          <p className="text-brand-amber font-medium tracking-widest uppercase text-sm mb-4 animate-fade-up">Lausanne · Cuisine asiatique</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter max-w-3xl animate-fade-up" style={{ animationDelay: "60ms" }}>
            Le meilleur de l'Asie, livré chaud chez vous.
          </h1>
          <p className="mt-6 text-lg text-white/80 max-w-xl animate-fade-up" style={{ animationDelay: "120ms" }}>
            Des plats asiatiques préparés à la commande. Livraison & à emporter à Lausanne.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 animate-fade-up" style={{ animationDelay: "180ms" }}>
            <Button onClick={() => navigate("/commander")} data-testid="hero-order-btn" className="rounded-none bg-brand-red hover:bg-brand-red/90 px-8 text-base h-12">
              Commander maintenant <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-16 grid gap-6 md:grid-cols-3" data-testid="home-features">
        {[
          { icon: Truck, t: "Livraison rapide", d: "Autour de Lausanne, à l'heure choisie." },
          { icon: ShoppingBag, t: "À emporter", d: "Prêt quand vous arrivez." },
          { icon: Star, t: "Fait maison", d: "Produits frais, recettes authentiques." },
        ].map((f, i) => (
          <div key={i} className="border border-black p-6">
            <f.icon className="w-8 h-8 text-brand-red" />
            <h3 className="mt-4 font-display text-xl font-bold tracking-tight">{f.t}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{f.d}</p>
          </div>
        ))}
      </section>

      <section className="max-w-6xl mx-auto px-4 pb-16 text-center" data-testid="home-cta">
        <h2 className="font-display text-4xl font-extrabold tracking-tighter">Envie d'Asie ?</h2>
        <p className="mt-3 text-muted-foreground">Découvrez toute la carte et commandez en quelques clics.</p>
        <Button onClick={() => navigate("/commander")} data-testid="cta-order-btn" className="mt-6 rounded-none bg-black hover:bg-black/90 px-8 h-12">
          Voir le menu <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </section>

      <Footer />
    </div>
  );
}
